// Časovač slouží pro zablokování tlačítek,

import { updateButtonState } from './forumValidate';

// Interval 120 koresponduje se současným nastavením BE
const intervalInSeconds = 120;
const TEXT_BUTTON = 'Odeslat komentář';

// Global proměnná interval ID
let currentTimerInterval: NodeJS.Timeout | null = null;

// Změnit stav tlačítka | text / disabled / class
interface ToggleDisabledButtonsAddCommentProps {
  className?: string;
  disabled?: boolean;
  innerText?: string;
}

// Funkce pro resetování textu tlačítek na výchozí
const resetButtonsText = (innerText: string = TEXT_BUTTON) => {
  const buttons: NodeListOf<HTMLButtonElement> = document.querySelectorAll('[data-add-comment]');

  if (buttons.length) {
    buttons.forEach((button: HTMLButtonElement) => {
      const textSpan = button.querySelector('.button__text');
      if (textSpan) textSpan.innerHTML = innerText;
    });
  }
};

const updateButtonsAddComment = ({
  className = 'button--locked',
  disabled = true,
  innerText = TEXT_BUTTON,
}: ToggleDisabledButtonsAddCommentProps = {}) => {
  // Nelze načíst z elementů - querySelectorAll musí znova projít dokument, protože mohl být naklonován formulář pro odpověď
  const buttons: NodeListOf<HTMLButtonElement> = document.querySelectorAll('[data-add-comment]');

  if (buttons.length) {
    buttons.forEach((button: HTMLButtonElement) => {
      // Najít span element s textem tlačítka
      const textSpan = button.querySelector('.button__text');

      if (textSpan) textSpan.innerHTML = innerText;

      if (innerText !== TEXT_BUTTON) {
        return;
      }

      // Změnit stav tlačítka
      button.disabled = disabled;

      // Prohodit class
      if (disabled) {
        button.classList.add(className);
      } else {
        button.classList.remove(className);
      }
    });
  }
};

// Funkce pro spuštění validace všech formulářů
const validateAllForms = (componentName: string) => {
  // Najít všechny formuláře s komentáři
  const forms = document.querySelectorAll('[data-add-comment]');

  forms.forEach((button) => {
    // Najít textarea pro tento formulář
    const form = button.closest('form');
    const textarea = form?.querySelector('textarea') as HTMLTextAreaElement;

    if (textarea && button instanceof HTMLElement) {
      // Zkontrolovat jestli má mention username
      const mentionMatch = textarea.value.match(/^@(\w+)\s/);
      const mentionUsername = mentionMatch ? mentionMatch[1] : undefined;

      // Spustit validaci
      updateButtonState({
        textarea,
        button,
        mentionUsername,
        componentName,
      });
    }
  });
};

// Funkce pro vymazání intervalu
const clearExistingTimer = () => {
  if (currentTimerInterval) {
    clearInterval(currentTimerInterval);
    currentTimerInterval = null;
  }
};

interface ForumTimerProps {
  init?: boolean;
  componentName?: string;
  buttonInfoText?: boolean;
}

export const forumTimer = ({
  init = false,
  componentName = 'cncForum',
  buttonInfoText = true,
}: ForumTimerProps = {}) => {
  // Vymazat existující intervaly
  clearExistingTimer();

  // Načíst proměnné z localStorage
  const keyStart = `${componentName}StartTime`;
  const keyEnd = `${componentName}EndTime`;

  let startTime: number;
  let endTime: number;

  if (init) {
    // Nastavit nový časovač
    startTime = Date.now();
    endTime = startTime + intervalInSeconds * 1000;

    // Save to localStorage
    localStorage.setItem(keyStart, String(startTime));
    localStorage.setItem(keyEnd, String(endTime));

    // Nastavit tlačítka jako disabled
    updateButtonsAddComment();
  } else {
    // Zkontrolovat jestli časovač běží
    const savedStartTime = localStorage.getItem(keyStart);
    const savedEndTime = localStorage.getItem(keyEnd);

    if (!savedStartTime || !savedEndTime) {
      return; // Žádný časovač
    }

    startTime = Number(savedStartTime);
    endTime = Number(savedEndTime);

    // Kontrola, jestli vypršel čas
    if (Date.now() >= endTime) {
      // Časovač vypršel, vyčistíme hodnoty a spustíme validaci
      localStorage.removeItem(keyStart);
      localStorage.removeItem(keyEnd);

      // Resetovat text tlačítek na výchozí
      resetButtonsText();

      // Spustit validaci místo pouze povolení tlačítek
      validateAllForms(componentName);
      return;
    }

    // Časovač běží, zakážeme tlačítka
    updateButtonsAddComment();
  }

  // Každou vteřinu
  currentTimerInterval = setInterval(() => {
    const now = Date.now();
    const remainingTime = Math.max(0, Math.ceil((endTime - now) / 1000));

    // Pokud se odečítá čas, upravit obsah tlačítek
    if (remainingTime > 0 && buttonInfoText) {
      updateButtonsAddComment({
        innerText: `${remainingTime}s do dalšího komentáře`,
      });
    }

    // Pokud interval vyprší
    if (remainingTime <= 0) {
      // Vymazat časovač
      clearExistingTimer();

      // Vyčistit úložiště
      localStorage.removeItem(keyStart);
      localStorage.removeItem(keyEnd);

      // Resetovat text tlačítek na výchozí
      resetButtonsText();

      // Spustit validaci místo pouze povolení tlačítek
      validateAllForms(componentName);
    }
  }, 1000);
};
